import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import emailLeakageService from "../../services/emailLeakageService";
import { getAccountScanPermissions } from "store/slices/scanPermissionsSlice";

export const getAllEmailLeakages = createAsyncThunk(
    "emailLeakage/allEmailLeakages",
    async ({ domainName, createdDate }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getAllEmailLeakages(
            domainName,
            createdDate
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getScanStatus = createAsyncThunk(
    "emailLeakage/scanStatus",
    async (scanId, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getScanStatus(scanId);
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getScanSummary = createAsyncThunk(
    "emailLeakage/scanSummary",
    async ({ scanId, by }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getScanSummary(scanId, by);
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getScanEventResults = createAsyncThunk(
    "emailLeakage/scanEventResults",
    async ({ scanId, eventType }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getScanEventResults(
            scanId,
            eventType
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const startEmailLeakageScan = createAsyncThunk(
    "emailLeakage/startEmailLeakageScan",
    async (domainId, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.startEmailLeakageScan(
            domainId
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getMailSearchByDomain = createAsyncThunk(
    "emailLeakage/mailSearchByDomain",
    async (domainId, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getMailSearchByDomain(domainId);
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const searchLeakageByEmail = createAsyncThunk(
    "emailLeakage/searchLeakageByEmail",
    async ({ leakageMailId, email }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.searchLeakageByEmail(
            leakageMailId,
            email
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const searchLeakageByCustomEmail = createAsyncThunk(
    "emailLeakage/searchLeakageByCustomEmail",
    async ({ email }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.searchLeakageByCustomEmail(
            email
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getNewMailLeakagesPageable = createAsyncThunk(
    "emailLeakage/getNewMailLeakagesPageable",
    async (data, { rejectWithValue, dispatch }) => {
      try {
        const response = await emailLeakageService.getNewMailLeakagesPageable(data);
        if (response.status === 200) {
          dispatch(getAccountScanPermissions());
        }
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getNewMailLeakage  = createAsyncThunk(
    "emailLeakage/getNewMailLeakage",
    async (formattedData, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getNewMailLeakage(formattedData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
);

export const startNewMailLeakage  = createAsyncThunk(
    "emailLeakage/startNewMailLeakage",
    async (formattedData, { rejectWithValue}) => {
      try {
        const response = await emailLeakageService.startNewMailLeakage(formattedData);
        return response;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
);

export const postMailLeakagesVip = createAsyncThunk(
    "emailLeakage/postMailLeakagesVip",
    async (formattedData, { rejectWithValue, dispatch }) => {
      try {
        const response = await emailLeakageService.postMailLeakagesVip(formattedData);
        if (response.status === 200) {
        dispatch(getAccountScanPermissions());
      }
        return response;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
);

export const getVipEmailLeakagesPageable = createAsyncThunk(
    "emailLeakage/getVipEmailLeakagesPageable",
    async (data, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getVipEmailLeakagesPageable(
            data?.params, data?.data
        );
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getVipEmailLeakagesDetails = createAsyncThunk(
    "emailLeakage/getVipEmailLeakagesDetails",
    async (id, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getVipEmailLeakagesDetails(id);
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const postUsernameLeakagesVip = createAsyncThunk(
    "emailLeakage/postUsernameLeakagesVip",
    async (formattedData, { rejectWithValue, dispatch }) => {
      try {
        const response = await emailLeakageService.postUsernameLeakagesVip(formattedData);
        if (response.status === 200) {
          dispatch(getAccountScanPermissions());
        }
        return response;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
);

export const getVipUsernameLeakagesPageable = createAsyncThunk(
    "emailLeakage/getVipUsernameLeakagesPageable",
    async (data, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getVipUsernameLeakagesPageable(
          data?.params,
          data?.data
        );
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const getVipUsernameLeakagesDetails = createAsyncThunk(
    "emailLeakage/getVipUsernameLeakagesDetails",
    async (id, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.getVipUsernameLeakagesDetails(id);
        return response;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

export const exportNewMailLeakagesExcel = createAsyncThunk(
    "emailLeakage/exportNewMailLeakagesExcel",
    async ({ id, filters }, { rejectWithValue }) => {
      try {
        const response = await emailLeakageService.exportNewMailLeakagesExcel(id, filters);
        return response.data;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
);

const initialState = {
  emailLeakages: [],
  emailLeakageLoading: false,
  scanStatus: {},
  scanSummary: {},
  scanEventResults: [],
  selectedEmailLeakage: {},
  emailLeakageName: "",
  detailLoading: false,
  canRefresh:false,
  fetchedEmails: [],
  leakedEmailData: {},
  leakedEmailLoading: false,
  leakedCustomEmailData: {},
  customLeakedEmailLoading: false,
  addingVipEmailsLoading: false,
  addingVipEmailsError: null,
  addingVipEmailsSuccess: null,
  vipEmailGroups: [],
  vipEmailGroupsLoading: false,
  vipEmailGroupsDetails: [],
  vipEmailGroupsDetailsLoading: false,
  addingVipUsernamesLoading: false,
  addingVipUsernamesError: null,
  addingVipUsernamesSuccess: null,
  vipUsernameGroups: [],
  vipUsernameGroupsLoading: false,
  vipUsernameGroupsDetails: [],
  vipUsernameGroupsDetailsLoading: false,
  leakedEmailDetailLoading: false,
  newMailLeakageLoading: false,
  newMailLeakageData: null,
  newMailLeakageError: false,
  startNewMailLeakageLoading: false,
  startNewMailLeakageData: null,
  startNewMailLeakageError: false,
  exportNewMailLeakagesLoading: false,
  exportNewMailLeakagesData: null,

  defaultEmailLeakagePageableRequest: {
    data: {
      name: ""
    },
    params: {
      page: 0,
      size: 6,
      sort: "createdDate",
      direction: "DESC"
    }
  },

  emailLeakageTablePageableRequest: {
    id: "",
    params: {
      page: 0,
      size: 10,
    }
  }
};

export const emailLeakageSlice = createSlice({
  name: "emailLeakageSlice",
  initialState,
  reducers: {
    selectedEmailLeakage: (state, action) => {
      state.selectedEmailLeakage = action.payload;
    },
    emailLeakageName: (state, action) => {
      state.emailLeakageName = action.payload;
    },
    setLeakedCustomEmailDataEmpty: (state, action) => {
      state.leakedCustomEmailData = {};
    },
    setAddingVipEmailsErrorEmpty: (state, action) => {
      state.addingVipEmailsError = null;
      state.addingVipEmailsSuccess = null;
    },
    setAddingVipUsernamesErrorEmpty: (state, action) => {
      state.addingVipUsernamesError = null;
      state.addingVipUsernamesSuccess = null;
    },
    setNewMailLeakageError: (state, action) => {
      state.newMailLeakageError = false;
    },
    setStartNewMailLeakageError: (state, action) => {
      state.startNewMailLeakageError = false;
    },
    clearExportNewMailLeakages: (state) => {
      state.exportNewMailLeakagesData = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEmailLeakages.fulfilled, (state, action) => {
      state.emailLeakages = action.payload.content;
      state.emailLeakageLoading = false;
    });
    builder.addCase(getAllEmailLeakages.pending, (state) => {
      state.emailLeakages = [];
      state.emailLeakageLoading = true;
    });
    builder.addCase(getAllEmailLeakages.rejected, (state) => {
      state.emailLeakageLoading = false;
    });
    builder.addCase(getScanStatus.fulfilled, (state, action) => {
      state.scanStatus = action.payload;
      state.detailLoading = false;
    });
    builder.addCase(getScanStatus.rejected, (state) => {
      state.scanStatus = {};
    });
    builder.addCase(getScanStatus.pending, (state) => {
      state.scanStatus = {};
      state.detailLoading = true;
    });
    builder.addCase(getScanSummary.fulfilled, (state, action) => {
      state.scanSummary = action.payload;
      state.detailLoading = false;
    });
    builder.addCase(getScanSummary.pending, (state) => {
      state.detailLoading = true;
    });
    builder.addCase(getScanSummary.rejected, (state) => {
      state.detailLoading = false;
    });
    builder.addCase(getScanEventResults.fulfilled, (state, action) => {
      state.scanEventResults = action.payload;
      state.detailLoading = false;
    });
    builder.addCase(getScanEventResults.rejected, (state) => {
      state.scanEventResults = [];
    });
    builder.addCase(getScanEventResults.pending, (state) => {
      state.scanEventResults = [];
      state.detailLoading = true;
    });
    builder.addCase(startEmailLeakageScan.fulfilled, (state) => {
      state.canRefresh = true;
    });
    builder.addCase(startEmailLeakageScan.rejected, (state) => {
      state.canRefresh = false;
    });
    builder.addCase(startEmailLeakageScan.pending, (state) => {
      state.canRefresh = false;
    });
    builder.addCase(getMailSearchByDomain.fulfilled, (state, action) => {
      state.fetchedEmails = action.payload;
    });
    builder.addCase(searchLeakageByEmail.fulfilled, (state, action) => {
      state.leakedEmailData = action.payload;
      state.leakedEmailDetailLoading = false;
    });
    builder.addCase(searchLeakageByEmail.pending, (state, action) => {
      state.leakedEmailData = action.payload;
      state.leakedEmailDetailLoading = true;
    });
    builder.addCase(searchLeakageByEmail.rejected, (state, action) => {
      state.leakedEmailData = action.payload;
      state.leakedEmailDetailLoading = false;
    });
    builder.addCase(searchLeakageByCustomEmail.fulfilled, (state, action) => {
      state.leakedCustomEmailData = action.payload;
      state.customLeakedEmailLoading = false;
    });
    builder.addCase(searchLeakageByCustomEmail.pending, (state, action) => {
      state.customLeakedEmailLoading = true;
    });
    builder.addCase(searchLeakageByCustomEmail.rejected, (state, action) => {
      state.leakedCustomEmailData = {};
      state.customLeakedEmailLoading = false;
    });
    builder.addCase(getNewMailLeakagesPageable.fulfilled, (state, action) => {
      state.fetchedEmails = action.payload;
      state.leakedEmailLoading = false;
    });
    builder.addCase(getNewMailLeakagesPageable.pending, (state) => {
      state.leakedEmailLoading = true;
    });
    builder.addCase(getNewMailLeakagesPageable.rejected, (state) => {
      state.leakedEmailLoading = false;
    });
    builder.addCase(postMailLeakagesVip.fulfilled, (state, action) => {
      if (action.payload?.status === 200) {
        state.addingVipEmailsSuccess = 'VIP emails added successfully!';
      } else {
        state.addingVipEmailsError = action?.payload?.response?.data?.error || 'Something Went Wrong While Adding Emails!';
      }
      state.addingVipEmailsLoading = false;
    });
    builder.addCase(postMailLeakagesVip.pending, (state, action) => {
      state.addingVipEmailsLoading = true;
    });
    builder.addCase(postMailLeakagesVip.rejected, (state, action) => {
      state.addingVipEmailsError = action?.payload;
      state.addingVipEmailsLoading = false;
    });
    builder.addCase(getVipEmailLeakagesPageable.fulfilled, (state, action) => {
      state.vipEmailGroups = action.payload.data;
      state.vipEmailGroupsLoading = false;
    });
    builder.addCase(getVipEmailLeakagesPageable.pending, (state, action) => {
      state.vipEmailGroupsLoading = true;
    });
    builder.addCase(getVipEmailLeakagesPageable.rejected, (state, action) => {
      state.vipEmailGroupsLoading = false;
    });
    builder.addCase(getVipEmailLeakagesDetails.fulfilled, (state, action) => {
      state.vipEmailGroupsDetails = action.payload.data;
      state.vipEmailGroupsDetailsLoading = false;
    });
    builder.addCase(getVipEmailLeakagesDetails.pending, (state, action) => {
      state.vipEmailGroupsDetailsLoading = true;
    });
    builder.addCase(getVipEmailLeakagesDetails.rejected, (state, action) => {
      state.vipEmailGroupsDetailsLoading = false;
    });
    builder.addCase(postUsernameLeakagesVip.fulfilled, (state, action) => {
      if (action.payload?.status === 200) {
        state.addingVipUsernamesSuccess = true;
      } else {
        state.addingVipUsernamesError = action?.payload?.response?.data?.error || 'Something went wrong while adding usernames.';
      }
      state.addingVipUsernamesLoading = false;
    });
    builder.addCase(postUsernameLeakagesVip.pending, (state) => {
      state.addingVipUsernamesLoading = true;
    });
    builder.addCase(postUsernameLeakagesVip.rejected, (state, action) => {
      state.addingVipUsernamesError = action?.payload;
      state.addingVipUsernamesLoading = false;
    });
    builder.addCase(getVipUsernameLeakagesPageable.fulfilled, (state, action) => {
      state.vipUsernameGroups = action.payload?.data || action.payload;
      state.vipUsernameGroupsLoading = false;
    });
    builder.addCase(getVipUsernameLeakagesPageable.pending, (state) => {
      state.vipUsernameGroupsLoading = true;
    });
    builder.addCase(getVipUsernameLeakagesPageable.rejected, (state) => {
      state.vipUsernameGroupsLoading = false;
    });
    builder.addCase(getVipUsernameLeakagesDetails.fulfilled, (state, action) => {
      const data = action.payload?.data ?? action.payload;
      state.vipUsernameGroupsDetails = Array.isArray(data) ? data : (data?.content ?? data);
      state.vipUsernameGroupsDetailsLoading = false;
    });
    builder.addCase(getVipUsernameLeakagesDetails.pending, (state) => {
      state.vipUsernameGroupsDetailsLoading = true;
    });
    builder.addCase(getVipUsernameLeakagesDetails.rejected, (state) => {
      state.vipUsernameGroupsDetailsLoading = false;
    });
    builder.addCase(getNewMailLeakage.fulfilled, (state, action) => {
      if (action?.payload?.response?.status === 500 || action?.payload?.response?.status === 404) {
        state.newMailLeakageError = true;
      }
      state.newMailLeakageData = action?.payload?.data;
      state.newMailLeakageLoading = false;
    });
    builder.addCase(getNewMailLeakage.pending, (state) => {
      state.newMailLeakageLoading = true;
    });
    builder.addCase(getNewMailLeakage.rejected, (state) => {
      state.newMailLeakageLoading = false;
    });
    builder.addCase(startNewMailLeakage.fulfilled, (state, action) => {
      if (action?.payload?.status === 200 || action?.payload?.status === 204) {
        
      } else {
        state.startNewMailLeakageError = true;
      }
      state.startNewMailLeakageData = action.payload;
      state.startNewMailLeakageLoading = false;
    });
    builder.addCase(startNewMailLeakage.pending, (state) => {
      state.startNewMailLeakageLoading = true;
    });
    builder.addCase(startNewMailLeakage.rejected, (state) => {
      state.startNewMailLeakageLoading = false;
    });
    builder.addCase(exportNewMailLeakagesExcel.pending, (state) => {
      state.exportNewMailLeakagesLoading = true;
    });
    builder.addCase(exportNewMailLeakagesExcel.fulfilled, (state, action) => {
      state.exportNewMailLeakagesLoading = false;
      state.exportNewMailLeakagesData = action.payload;
    });
    builder.addCase(exportNewMailLeakagesExcel.rejected, (state) => {
      state.exportNewMailLeakagesLoading = false;
    });
  },
});

export const {
  selectedEmailLeakage,
  scanStatus,
  scanSummary,
  emailLeakages,
  emailLeakageName,
  setLeakedCustomEmailDataEmpty,
  setAddingVipEmailsErrorEmpty,
  setAddingVipUsernamesErrorEmpty,
  setStartNewMailLeakageError,
  setNewMailLeakageError,
  clearExportNewMailLeakages
} = emailLeakageSlice.actions;

export default emailLeakageSlice.reducer;